import MaskedInput from 'react-text-mask';
import styled from 'styled-components/macro';

export const Suffix = styled.h6<{ table?: boolean; error?: boolean }>`
  position: absolute;
  top: ${({ table }) => (table ? 'calc(50% - 7px )' : 'calc(50% + 5px)')};
  right: 0.5rem;

  height: 1rem;

  color: ${({ theme, error }) => (error ? theme.colors.negative_dark : theme.colors.black_60)};
  font-weight: ${({ theme }) => theme.fontWeight.medium};
  font-size: ${({ theme }) => theme.fontSize.xxs};
  font-family: ${({ theme }) => theme.fontFamily.medium};
  font-style: normal;
  font-stretch: normal;
  line-height: ${({ theme }) => theme.lineHeight.one_1};
  letter-spacing: ${({ theme }) => theme.letterSpacing.md};
  text-align: right;

  background: white;
`;

export const Input = styled(MaskedInput)<{ error?: string }>`
  position: relative;

  width: 100%;
  height: 2.5rem;
  padding: ${({ theme }) => theme.spacing.zero} ${({ theme }) => theme.spacing.zero_3};
  border: 1px solid;
  border-color: ${({ theme, error }) =>
    error === 'hasError' ? theme.colors.negative_dark : theme.colors.black_10};
  border-radius: ${({ theme }) => theme.spacing.zero_1};

  ::placeholder {
    color: ${({ theme }) => theme.colors.black};
  }

  background-color: ${({ theme }) => theme.colors.white};
  outline: none;

  :focus {
    border: 1px solid;
    border-color: ${props =>
      props.error === 'hasError' ? props.theme.colors.negative_dark : props.theme.colors.black};
  }
  :disabled {
    color: ${({ theme }) => theme.colors.black_40};

    background-color: ${({ theme }) => theme.colors.black_5};
  }
`;
